import { ApiCatch } from "@/utils/decorators";
import {
  DelReqDTO,
  RequestsDTO,
  SaveFileByCodeNameDTO,
  SaveFileDTO,
  SavePlanDTO,
  SaveRequestDTO,
  SendReqDTO,
  SignedDTO,
} from "~/requests.type";
import { Api } from "../api.service";

export class RequestsService {
  @ApiCatch
  static async getRefRegions() {
    const response = await Api.get("/requests/getRefRegions");
    return response.data;
  }
  @ApiCatch
  static async getBanksForRefs() {
    const response = await Api.get("/requests/getBanksForRefs");
    return response.data;
  }
  @ApiCatch
  static async getOrgBranches() {
    const response = await Api.get("/requests/getOrgBranches");
    return response.data;
  }
  @ApiCatch
  static async getOrgTypes() {
    const response = await Api.get("/requests/getOrgTypes");
    return response.data;
  }

  @ApiCatch
  static async getRequestList(req: RequestsDTO) {
    const response = await Api.get("/requests/list", { params: req });
    return response.data;
  }

  @ApiCatch
  static async getAttachments(CRRID: number) {
    const response = await Api.get("/requests/attachments", {
      params: { CRRID: CRRID },
    });
    return response.data;
  }

  @ApiCatch
  static async addEditReq(req: SaveRequestDTO) {
    const response = await Api.post(
      "/requests/createUpdateContractorRequest",
      req,
    );
    return response.data;
  }

  @ApiCatch
  static async getContractorRequest(RID: number) {
    const response = await Api.get("/requests/getContractorRequest", {
      params: { RID: RID },
    });
    return response.data;
  }

  @ApiCatch
  static async getRequestPlan(RID: number) {
    const response = await Api.get("/requests/getRequestPlan", {
      params: { RID: RID },
    });
    return response.data;
  }

  @ApiCatch
  static async addEditPlan(req: SavePlanDTO) {
    const response = await Api.post("/requests/createUpdatePlan", req);
    return response.data;
  }

  @ApiCatch
  static async uploadFile(req: SaveFileDTO) {
    const response = await Api.post(
      "/requests/uploadfile?RID=" +
      req.RID.toString() +
      "&attatchment_type_rid=" +
      req.attatchment_type_rid.toString(),
      req.data,
    );
    return response.data;
  }

  @ApiCatch
  static async uploadfileByCodeName(req: SaveFileByCodeNameDTO) {
    const response = await Api.post(
      "/requests/saveFileByCodeName?RID=" +
      req.RID.toString() +
      "&attatchment_type_code=" +
      req.attatchment_type_code,
      req.data,
    );
    return response.data;
  }

  @ApiCatch
  static async getFile(attach_id: number) {
    const response = await Api.get("/requests/getFile", {
      params: { attach_id: attach_id },
    });
    return response.data;
  }

  @ApiCatch
  static async deleteAttachment(attach_id: number) {
    const response = await Api.get("/requests/deleteAttachment", {
      params: { attach_id: attach_id },
    });
    return response.data;
  }

  @ApiCatch
  static async sendReqToConsidering(req: SendReqDTO) {
    const response = await Api.post("/requests/sendReqToConsidering", req);
    return response.data;
  }

  @ApiCatch
  static async deleteRequest(req: DelReqDTO) {
    const response = await Api.post("/requests/deleteRequest", req);
    return response.data;
  }

  @ApiCatch
  static async getAttachmentByCodeName(CCRID: number, CodeName: string) {
    const response = await Api.post("/requests/getAttachmentByCodeName", {
      CCRID: CCRID,
      CodeName: CodeName,
    });
    return response.data;
  }

  @ApiCatch
  static async sendReqToSigned(req: SignedDTO) {
    const response = await Api.post("/requests/sendReqToSigned", req);
    return response.data;
  }
}
